export class DocumentTest {
    /** @type {int} */
    currentQuestion = 1;

    /** @type {?int} */
    currentSelectedAnswer = null;

    /** @type {Map} */
    answeredQuestionsPath = new Map().set(this.currentQuestion, null);

    /** @type {boolean} */
    hasFinished = false;

    /** @type {DocumentForm} */
    documentForm = null;

    constructor(documentForm) {
        this.documentForm = documentForm;
    }

    get currentQuestionTitle() {
        return this.documentForm.questions[this.currentQuestion - 1].title;
    }

    get currentQuestionAnswers() {
        return this.documentForm.questions[this.currentQuestion - 1].answers;
    }

    get questionCount() {
        return this.documentForm.questions.length;
    }

    get currentQuestionSelectedAnswer() {
        return this.answeredQuestionsPath.get(this.currentQuestion);
    }

    set currentQuestionSelectedAnswer(val) {
        this.answeredQuestionsPath.set(this.currentQuestion, val);
    }

    get isFirstQuestion() {
        return this.currentQuestion === 1;
    }

    get isLastQuestion() {
        return this.documentForm.questions.length === this.currentQuestion;
    }

    goBack() {
        this.currentQuestion = this.isFirstQuestion ? this.currentQuestion : --this.currentQuestion;
    }

    goToNextQuestion() {
        this.currentSelectedAnswer = null;
        this.currentQuestion++;
    }

    markAsFinished() {
        this.hasFinished = true;
    }
}